module.exports = __webpack_public_path__ + "static/Adsr_panel-a3956768af06deec4db563051ef002ec.png";